export const examAdminRolePermissions = {
  catalogTitle: "Role Catalog",
  catalogLoadFailed: "Role catalog failed to load",
  catalogContractInvalid: "Role catalog contract anomaly",
  catalogContractDescription:
    "The backend must explicitly return the role-catalog.roles array; development mode does not fall back to an empty catalog.",
  matrixTitle: "Permission Matrix",
  matrixBlocked: "Role catalog anomaly; permission matrix paused",
  permissionColumn: "Permission",
  allowed: "Allowed",
  denied: "Denied",
  status: {
    active: "Active",
    inactive: "Inactive",
  },
  permissions: {
    dashboard: "Dashboard",
    candidateUsers: "Candidate Directory",
    users: "User Management",
    resetUserPassword: "Reset User Password",
    impersonateCandidate: "Impersonate Candidate",
    system: "System Settings",
    auditLogs: "Audit Logs",
    questions: "Question Bank",
    archiveQuestions: "Archive Questions",
    deleteQuestions: "Delete Questions",
    publishQuestions: "Publish Questions",
    questionExperience: "Question Experience Governance",
    papers: "Paper Management",
    exams: "Exam Management",
    execution: "Runtime Monitoring",
    docker: "Environment Instances",
    assets: "Assets Center",
    review: "Review and Grading",
  },
};
